(function () {
  angular.module('binky.core.directories.domains', [
    'binky.core.api.jil',
    'binky.core.common.list',
    'binky.core.common.model.cache',
    'binky.core.domains',
    'binky.core.lodash',
  ]);
})();
